import { Component, OnInit } from '@angular/core';
import { OrdemServico, OSTecnicoDeslocamento } from './ordem-servico.model';
import { DxFormModule } from 'devextreme-angular';
import { adicionaIconesGrid } from '../app.config';
import { ServicoService } from '../servico/servico.service';
import { TecnicoService } from '../tecnico/tecnico.service';
import { OrdemServicoService } from './ordem-servico.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemSerieService } from './../item-serie/item-serie.service';
import { ProdutoPacoteService } from './../produto-pacote/produto-pacote.service';
import notify from 'devextreme/ui/notify';
import { MotivoCancelamentoService } from './../motivo-cancelamento/motivo-cancelamento.service';
import { EquipeService } from '../equipe/equipe.service';
import { listaEstadosAndamento } from '../shared/listas-parametros';

@Component({
  selector: 'ntc-ordem-servico',
  templateUrl: './ordem-servico.component.html',
  styleUrls: ['./ordem-servico.component.css']
})
export class OrdemServicoComponent implements OnInit {

  ordemServicoForm: OrdemServico;
  ordemServicoTecnicoDeslocamento: OSTecnicoDeslocamento;

  loadingVisible = false;
  tab = [true, false, false];
  itemsForm = null;

  listaTipoOrdemServico = [
    {Tipo: 'Avulsa'},
    {Tipo: 'Atendimento'}
  ];

  listaSimNao = [
    {Id: 'S', Descricao: 'SIM'},
    {Id: 'N', Descricao: 'NÃO'}
  ];

  listaServico = [];
  listaTecnico = [];
  listaEquipe = [];
  listaEstadosAndamento = listaEstadosAndamento;
  /* listaEstadosAndamento = [
    {Id: '1', DescricaoEstadosAndamento: 'Pendente'},
    {Id: '2', DescricaoEstadosAndamento: 'Agendado'},
    {Id: '3', DescricaoEstadosAndamento: 'Procedente SIM'},
    {Id: '4', DescricaoEstadosAndamento: 'Procedente NÃO'},
    {Id: '5', DescricaoEstadosAndamento: 'Recorrente'},
    {Id: '6', DescricaoEstadosAndamento: 'Finalizado'},
    {Id: '7', DescricaoEstadosAndamento: 'Cancelado'}
  ];*/

  listaProdutoPacote = [];
  listaItemSerie = [];
  listaPontoTipo = [
    {Id: '1', DescricaoPontoTipo: 'Principal'},
    {Id: '2', DescricaoPontoTipo: 'Adicional'},
    {Id: '3', DescricaoPontoTipo: 'Cortesia'}
  ];
  listaMotivoCancelamento = [];

  listasForm = [
    {Nome: 'listaTipoOrdemServico', status: true},
    {Nome: 'listaSimNao', status: true},
    {Nome: 'listaServico', status: false},
    {Nome: 'listaTecnico', status: false},
    {Nome: 'listaEquipe', status: false},
    {Nome: 'listaEstadosAndamento', status: true},
    {Nome: 'listaProdutoPacote', status: false},
    {Nome: 'listaItemSerie', status: false},
    {Nome: 'listaPontoTipo', status: true},
    {Nome: 'listaMotivoCancelamento', status: false}
  ];

  constructor(
    private ordemServicoService: OrdemServicoService,
    private servicoService: ServicoService,
    private tecnicoService: TecnicoService,
    private produtoPacoteService: ProdutoPacoteService,
    private itemSerieService: ItemSerieService,
    private motivoCancelamentoService: MotivoCancelamentoService,
    private router: Router,
    private route: ActivatedRoute,
    private equipeService: EquipeService
  ) {
    this.loadingVisible = true;

    this.ordemServicoForm = new OrdemServico();

    // verifica se é alteração ou novo cadastro
    if (this.route.snapshot.params['id'] !== undefined) {
      this.ordemServicoService.getOrdemServicoById(this.route.snapshot.params['id'])
        .subscribe(ordemServico => this.ordemServicoForm = ordemServico);

      // carrega deslocamentos da O.S.
      ordemServicoService.getOrdemServicoTecnicoDeslocamento(this.route.snapshot.params['id'])
        .subscribe(deslocamentos => this.ordemServicoTecnicoDeslocamento = deslocamentos);

    } else {
      this.ordemServicoForm.DtHrCadastro = new Date();
      this.ordemServicoForm.IdProtocolo = null;
    }

    // carrega listas
    servicoService.getServicos().subscribe(servicos => {
      this.listaServico = servicos;
      this.verificarListasCarregadas('listaServico');
    },
    error => {
      this.verificarListasCarregadas('listaServico');
    });

    tecnicoService.getTecnicos().subscribe(tecnicos => {
      this.listaTecnico = tecnicos;
      this.verificarListasCarregadas('listaTecnico');
    },
    error => {
      this.verificarListasCarregadas('listaTecnico');
    });

    produtoPacoteService.getProdutoPacote().subscribe(produtoPacotes => {
      this.listaProdutoPacote = produtoPacotes;
      this.verificarListasCarregadas('listaProdutoPacote');
    },
    error => {
      this.verificarListasCarregadas('listaProdutoPacote');
    });

    itemSerieService.getItensSerie().subscribe(itensSerie => {
      this.listaItemSerie = itensSerie;
      this.verificarListasCarregadas('listaItemSerie');
    },
    error => {
      this.verificarListasCarregadas('listaItemSerie');
    });

    motivoCancelamentoService.getMotivoCancelamentos().subscribe(motivosCancelamento => {
      this.listaMotivoCancelamento = motivosCancelamento;
      this.verificarListasCarregadas('listaMotivoCancelamento');
    },
    error => {
      this.verificarListasCarregadas('listaMotivoCancelamento');
    });

    equipeService.getEquipes().subscribe(listaEquipe => {
      this.listaEquipe = listaEquipe;
      this.verificarListasCarregadas('listaEquipe');
    },
    error => {
      this.verificarListasCarregadas('listaEquipe');
    });

  }

  ngOnInit() {

  }

  onRowInserted(e) {
    console.log(this.ordemServicoForm.OSServicos.length);
    const ultimoInserido = this.ordemServicoForm.OSServicos.length - 1;

    if (this.ordemServicoForm.OSServicos[ultimoInserido].OSPontos === undefined) {
      this.ordemServicoForm.OSServicos[ultimoInserido].OSPontos = [];
    }
    console.log(this.ordemServicoForm.OSServicos[ultimoInserido].OSPontos);

    if (this.ordemServicoForm.OSServicos[ultimoInserido].OSItens === undefined) {
      this.ordemServicoForm.OSServicos[ultimoInserido].OSItens = [];
    }
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  gravar = function(params: any) {
    const result = params.validationGroup.validate();

    if (result.isValid) {

      this.ordemServicoService.gravarOrdemServico(this.ordemServicoForm)
        .subscribe((ret: OrdemServico) => {
          // console.log(`Ordem de serviço gravado com sucesso! ${ret.Id}`);
          notify(`Ordem de serviço gravado com sucesso! ${ret.Id}`, 'success', 2000);
          this.router.navigate(['/ordens-servico']);
        });

    } else {
      // console.log(`Erro ao gravar Ordem de serviço`);
      notify(`Erro ao gravar Ordem de serviço`, 'error', 2000);
    }
  };

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if ( (this.listasForm[0].status === true) &&
         (this.listasForm[1].status === true) &&
         (this.listasForm[2].status === true) &&
         (this.listasForm[3].status === true) &&
         (this.listasForm[4].status === true) &&
         (this.listasForm[5].status === true) &&
         (this.listasForm[6].status === true) &&
         (this.listasForm[7].status === true) &&
         (this.listasForm[8].status === true) &&
         (this.listasForm[9].status === true) ) {

      this.montaForm();

      return true;
    } else {
      return false;
    }
  }

  montaForm = function() {
    this.itemsForm = [
      {
        itemType: 'group',
        caption: 'Ordem de Servico',
        items: [
          {
            dataField: 'Id',
            editorType: 'dxTextBox',
            label: { text: 'ID  ' },
            editorOptions: { disabled: true }
          },
          {
            dataField: 'DescricaoSolicitacao',
            editorType: 'dxTextBox',
            label: { text: 'Descrição da Solicitação' },
            validationRules: [{
              type: 'required',
              message: 'Descrição da Solicitação é obrigatório.'
            }]
          },
          {
            dataField: 'OrdemServicoTipo',
            editorType: 'dxSelectBox',
            label: { text: 'Tipo de Ordem de Servico' },
            editorOptions: { items: this.listaTipoOrdemServico, displayExpr: 'Tipo', valueExpr: 'Tipo' },
            validationRules: [{
              type: 'required',
              message: 'Tipo de Ordem de Serviço é obrigatório.'
            }]
          },
          {
            dataField: 'DtHrCadastro',
            editorType: 'dxDateBox',
            label: { text: 'Data de Cadastro' },
            editorOptions: { width: '100%', disabled: true }
          },
          {
            dataField: 'IdEquipe',
            editorType: 'dxSelectBox',
            label: { text: 'Equipe' },
            editorOptions: {  items: this.listaEquipe, displayExpr: 'DescricaoEquipe', valueExpr: 'Id', width: '100%', disabled: true }
          },
          {
            dataField: 'VisitaImprodutiva',
            editorType: 'dxSelectBox',
            label: { text: 'Visita Improdutiva' },
            editorOptions: { items: this.listaSimNao, displayExpr: 'Descricao', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Visita  Improdutiva é obrigatório.'
            }]
          },
          {
            dataField: 'Observacao',
            label: { text: 'Observações' },
            editorType: 'dxTextArea',
            editorOptions: { height: 90 },
            colSpan: '2'
          },
        ]
      }
    ];

    this.loadingVisible = false;
  };

  tabAtivo(tabIndex) {
    for (const i in this.tab) {
        this.tab[i] = false;
    }

    this.tab[tabIndex] = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/ordem-servico/ordem-servico.component.ts